import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Temoignage() {
  const { t } = useTranslation('refection');
  const { ref, isVisible } = useScrollReveal<HTMLElement>(0.1);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section ref={ref} id="temoignage" className="bg-white py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6 lg:px-10">
        <div
          className={`bg-soft-gray rounded-2xl overflow-hidden transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <div className="grid grid-cols-1 lg:grid-cols-5">
            {/* Image */}
            <div className="lg:col-span-2 h-64 md:h-80 lg:h-auto">
              <img
                src="https://readdy.ai/api/search-image?query=beautiful%20Canadian%20house%20in%20Pintendre%20Quebec%20with%20brand%20new%20grey%20asphalt%20shingle%20roof%20just%20installed%20bright%20sunny%20day%20blue%20sky%20white%20trim%20green%20lawn%20professional%20real%20estate%20photography%20warm%20natural%20light%20high%20quality&width=800&height=600&seq=reftem1&orientation=landscape"
                alt="Maison après réfection de toiture neuve à Pintendre près de Lévis par couvreur RBQ"
                className="w-full h-full object-cover object-center"
                loading="lazy"
                width="800"
                height="600"
                width="800"
                height="600"
              />
            </div>

            {/* Contenu */}
            <div className="lg:col-span-3 p-6 md:p-10 lg:p-12 flex flex-col justify-center">
              <div className="mb-6">
                <span className="inline-flex items-center gap-1 text-copper font-semibold text-sm mb-4">
                  <i className="ri-double-quotes-l text-lg" />
                  Témoignage client
                </span>
                <p className="text-slate-primary/70 text-sm md:text-base leading-relaxed italic">
                  "{t('temoin_text')}"
                </p>
              </div>

              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-6 border-t border-soft-dark">
                <div>
                  <p className="font-manrope font-bold text-slate-primary text-sm md:text-base">
                    {t('temoin_name')}
                  </p>
                  <p className="text-slate-primary/50 text-xs md:text-sm">
                    {t('temoin_location')} — {t('temoin_project')}
                  </p>
                </div>
                <button
                  onClick={() => scrollToSection('quote-form')}
                  className="inline-flex items-center gap-2 bg-copper hover:bg-copper-dark text-white font-semibold px-5 py-2.5 rounded-md text-sm transition-all duration-300 whitespace-nowrap"
                >
                  {t('temoin_cta')}
                  <i className="ri-arrow-right-line" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className="text-slate-primary/40 text-xs mt-8 text-center italic max-w-3xl mx-auto">
        Témoignages représentatifs de clients ayant utilisé notre service de mise en relation.
      </p>
    </section>
  );
}